import { Career } from "./Career";

export class Candidate {
    public actualCareer: Career;
    public assignedCareer: Career;
    public object: Phaser.Physics.Arcade.Sprite;
    public tryToTrickPlayer: boolean;
    public enabled: boolean;

    constructor(actualCareer: Career, tryToTrickPlayer: boolean) {
        this.actualCareer = actualCareer;
        this.assignedCareer = null;
        this.object = null;
        this.tryToTrickPlayer = tryToTrickPlayer;
        this.enabled = true;
    }

    public static CANDIDATES: Candidate[] = [
        new Candidate(Career.CAREERS[0], true),
        new Candidate(Career.CAREERS[1], false),
        new Candidate(Career.CAREERS[2], true),
        new Candidate(Career.CAREERS[3], false),
        new Candidate(null, false),
        new Candidate(null, false),
        new Candidate(null, false),
        new Candidate(null, false),
        new Candidate(null, false),
        new Candidate(null, false),
    ];
}



// WEBPACK FOOTER //
// ./src/games/CareerFairGame/objects/Candidate.ts